import { render, staticRenderFns } from "./LabelProcessing.vue?vue&type=template&id=49374321&scoped=true"
import script from "./LabelProcessing.vue?vue&type=script&lang=ts"
export * from "./LabelProcessing.vue?vue&type=script&lang=ts"
import style0 from "./LabelProcessing.vue?vue&type=style&index=0&id=49374321&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49374321",
  null
  
)

export default component.exports